import {ErrorPage} from "../../booking/components/ErrorPages/ErrorPage";
// import {ErrorPage} from "ui/booking/components/ErrorPages/ErrorPage";
import logo from "../../../theme/img/logo/logo2020-500.png";
import {BackButton, ButtonArea} from "./Buttons";
import {generate} from "../../../routing/routes";
import React from "react";
import {useTranslation} from "react-i18next";

export const ErrorHandler = () =>{
    const { t } = useTranslation();

    return <ErrorPage>
        <div className="bg-white py-24 px-6 sm:py-32 lg:px-8">
            <div className="mx-auto max-w-2xl text-center">
                <img src={logo} alt="logo" className={"w-40 mx-auto"} />

                <p className="mt-10 text-lg leading-8 text-gray-600">
                    Une erreur est apparue, désolé pour ce désagrément.
                    <br />
                    Veuillez rééssayer plus tard.
                </p>
                <div className="mt-6 text-lg leading-8 text-gray-600">
                    <ButtonArea>
                        <BackButton href={generate('account_dashboard')}>{t('account_button.dashboard')}</BackButton>
                    </ButtonArea>
                </div>

            </div>
        </div></ErrorPage>
}